import type { TableActionSpec } from '@/@vxapp/@Types/ServiceMetadata'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import { ProductCategoryField } from '@/@vxapp/@Enums/PHP/ServicesV2/Products/Categories/DataProviders/ProductCategoryField'

export const ProductCategoriesTableActions = [
  {
    id: 'edit',
    title: 'Edit',
    tooltip: 'Edit Category',
    icon: 'tabler-pencil',
    color: 'primary',
    disabled: false,
    hidden: false,
    emit: 'edit',
  },
  {
    id: 'preview',
    title: 'Preview',
    tooltip: 'View Category',
    icon: 'tabler-eye',
    color: 'primary',
    disabled: false,
    hidden: false,
    route: {
      name: PageMeta.Categories.Preview.Name || '',
      paramKey: 'guid',
      itemKey: ProductCategoryField.DB_IDENTIFIER,
    },
    emit: 'preview',
  },
] as const satisfies readonly TableActionSpec[]
